/*
 * Cart drawer upsell ("A little something extra") size picker.
 * Markup: snippets/drawer-product.liquid. Replaces the SwatchKing size popup.
 * Delegated on document so it keeps working after the cart drawer re-renders.
 */
(function () {
  if (window.agDrawerUpsellInit) return;
  window.agDrawerUpsellInit = true;

  function setOpen(wrapper, open) {
    var toggle = wrapper.querySelector('[data-ag-upsell-toggle]');
    var list = wrapper.querySelector('.ag-upsell__sizes');
    if (!toggle || !list) return;
    wrapper.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    list.hidden = !open;
  }

  function closeAll(except) {
    document.querySelectorAll('[data-ag-upsell].is-open').forEach(function (wrapper) {
      if (wrapper !== except) setOpen(wrapper, false);
    });
  }

  function selectSize(button) {
    var wrapper = button.closest('[data-ag-upsell]');
    var input = wrapper.querySelector('input[name="id"]');
    var label = wrapper.querySelector('[data-ag-upsell-label]');
    var submit = wrapper.querySelector('[type="submit"]');

    wrapper.querySelectorAll('[data-ag-upsell-size]').forEach(function (size) {
      size.setAttribute('aria-selected', size === button ? 'true' : 'false');
    });

    input.value = button.dataset.variantId;
    input.dataset.agSelected = 'true';
    if (label) label.textContent = label.dataset.defaultLabel + ': ' + button.dataset.value;
    wrapper.classList.remove('is-invalid');

    // Reset a previous "sold out" error state from product-form.js
    if (submit) {
      submit.removeAttribute('aria-disabled');
      var text = submit.querySelector('span');
      var soldOut = submit.querySelector('.sold-out-message');
      if (text) text.classList.remove('hidden');
      if (soldOut) soldOut.classList.add('hidden');
      var productForm = submit.closest('product-form');
      if (productForm) productForm.error = false;
    }

    setOpen(wrapper, false);
  }

  document.addEventListener(
    'click',
    function (event) {
      var toggle = event.target.closest('[data-ag-upsell-toggle]');
      if (toggle) {
        event.preventDefault();
        var wrapper = toggle.closest('[data-ag-upsell]');
        closeAll(wrapper);
        setOpen(wrapper, !wrapper.classList.contains('is-open'));
        return;
      }

      var size = event.target.closest('[data-ag-upsell-size]');
      if (size) {
        event.preventDefault();
        if (!size.disabled) selectSize(size);
        return;
      }

      var submit = event.target.closest('[data-ag-upsell] [type="submit"]');
      if (submit) {
        var upsell = submit.closest('[data-ag-upsell]');
        var required = upsell.querySelector('[data-ag-upsell-required]');
        if (required && required.dataset.agSelected !== 'true') {
          // No size chosen yet: open the list instead of adding a default size
          event.preventDefault();
          event.stopPropagation();
          upsell.classList.add('is-invalid');
          closeAll(upsell);
          setOpen(upsell, true);
        }
        return;
      }

      closeAll(null);
    },
    true
  );

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();
